import React from "react";
import PageContainer from "components/lib/PageContainer";
import { Segment } from "semantic-ui-react";
import { UserContainer } from "containers";
import { useParams } from "react-router-dom";
import { StoreIdParam } from "config/raven";
import { NewFormContainer } from "components/SiteManage/Content/Yaml/New/NewFormContainer";
import { StoreBreadcrumbBuilder } from "utils/breadcrumb";

export const YamlNew: React.FC = () => {
  const userContainer = UserContainer.useContainer();
  const { isAgency } = userContainer;
  const { storeId } = useParams<StoreIdParam>();

  return (
    <PageContainer
      header="新規作成"
      breadcrumbs={new StoreBreadcrumbBuilder(isAgency, storeId)
        .siteManagePage()
        .build("YAML管理 新規作成")}
    >
      <Segment>
        <NewFormContainer isAgency={isAgency} storeId={storeId} />
      </Segment>
    </PageContainer>
  );
};
